import type { StateCreator } from 'zustand/vanilla';

import type { SharingStore } from '../../store';
import { initialWizardUiState } from './initial-state';

export interface SharingWizardUiAction {
  /** Jump directly to a given step index in the stepper. */
  setCurrentStep: (step: number) => void;
  /** Advance to the next step. */
  nextStep: () => void;
  /** Go back to the previous step. No-op if already at the first step. */
  previousStep: () => void;
  /** Toggle whether the stepper is in edit mode (editing an existing profile) vs. create mode. */
  setEditMode: (isEditMode: boolean) => void;
  /** Mark whether the current draft has unsaved changes. */
  setUnsavedChanges: (hasUnsavedChanges: boolean) => void;
  /** Reset the wizard step, edit mode, and unsaved-changes flag back to their initial values. */
  resetWizard: () => void;
}

export const createWizardUiSlice: StateCreator<SharingStore, [['zustand/devtools', never]], [], SharingWizardUiAction> = (set, get) => ({
  setCurrentStep: (step) => {
    set({ currentStep: step });
  },

  nextStep: () => {
    set({ currentStep: get().currentStep + 1 });
  },

  previousStep: () => {
    set({ currentStep: Math.max(0, get().currentStep - 1) });
  },

  setEditMode: (isEditMode) => {
    set({ isEditMode });
  },

  setUnsavedChanges: (hasUnsavedChanges) => {
    set({ hasUnsavedChanges });
  },

  resetWizard: () => {
    set({ ...initialWizardUiState });
  },
});
